import _ from 'lodash';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'contentMatrixElements' implicitly has an 'any' type.
const buildContentMatrixElementQueryString = (contentMatrixElements) =>
  _.join(_.uniq(_.map(contentMatrixElements, (contentMatrixElement) => contentMatrixElement.query)));

export { buildContentMatrixElementQueryString };
